module.exports = __webpack_public_path__ + "img/background1.235f2932.png";